// @codekit-prepend "../../node_modules/jquery/dist/jquery.js";
// @codekit-prepend "../../node_modules/foundation-sites/dist/js/foundation.min.js";
// @codekit-prepend "../../node_modules/@accessible360/accessible-slick/slick/slick.min.js";

jQuery(function ($) {

	// Call the pretty Foundation scripts
	$(document).foundation();

	// Make the entire div containing link clickable.
	$(".link-box").click(function(){
		if($(this).find("a").length){
	       window.location.href = $(this).find("a:first").attr("href");
	       var $a = $(this).find("a:first");
	       window.open($a.attr("href"), $a.attr("target") || '_self');
	       return false;
		}
	});

	// Insert screen reader text for pagination on archive pages.
	$(".page-numbers a:not(.next)").each(function() {
		$(this).prepend('<span class="sr-only">Page number </span>');
	});

	// Add aria-labels to required form fields
	$('.frm_required').each(function() {
		$(this).parent().attr('aria-label', 'This is a required field');
		$(this).text('* (required)');
	})

	// Gallery Slideshow
	$('.gallery-slideshow .small-10').slick({
		arrows: true,
		dots: false,
		infinite: true,
		speed: 500,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: '<button class="slick-next slick-arrow" type="button" style=""><span class="slick-next-icon" aria-hidden="true"><i class="fa-solid fa-arrow-right"></i></span><span class="slick-sr-only">Next</span></button>',
		prevArrow: '<button class="slick-prev slick-arrow" type="button" style=""><span class="slick-prev-icon" aria-hidden="true"><i class="fa-solid fa-arrow-left"></i></span><span class="slick-sr-only">Next</span></button>'
	});

	// Remove anchor around product images.
	$('.woocommerce-product-gallery__image > a').each(function() {
		$(this).replaceWith('<div>' + $(this).html() + '</div>');
	})

	/*****
	 * Alert Banner
	*******/

	// Get current time.
	var currentTime = new Date().getTime();

	// Add hours function.
	Date.prototype.addHours = function(h) {    
		this.setTime( this.getTime() + ( h*60*60*1000) ); 
		return this;   
	}

	// Get time after 24 hours.
	var after24 = new Date().addHours(10).getTime();

	// Hide alert banner on click.
	$( '.site-alert__close' ).click( function() {
		$(this).closest( '.site-alert' ).fadeOut();
		localStorage.setItem( 'desiredTime', after24 ); 
	});

	// Show / Hide alert base on time.
	if( localStorage.getItem( 'desiredTime' ) >= currentTime ) {
		$( '.site-alert' ).addClass( 'hide' );
	} else {
		$( '.site-alert' ).removeClass( 'hide' );
	}
});
